(() => {
  if (customElements.get('splide-slider-component') || !window.Splide) {
    return;
  }

  class Slider extends HTMLElement {
    constructor() {
      super();

      // Initialize options object first to prevent "Cannot set properties of undefined" errors when property setters try to update this.options
      this.options = {
        pagination: false,
        perMove: 1,
      };

      this.gap = this.dataset.gap ?? '2.4rem';
      this.perPage = this.dataset.perPage ? this.dataset.perPage : 3;
      this.mobileSlides = typeof this.dataset.mobileSlides === 'undefined' ? 1 : this.dataset.mobileSlides;
      this.type = this.dataset.type ?? 'slide';
      this.options = {
        perPage: this.perPage,
        pagination: false,
        gap: this.gap,
        perMove: 1,
        type: this.type,
      };
    }

    // Get and set property accessor for perPage
    get perPage() {
      return this._perPage;
    }

    set perPage(value) {
      this._perPage = parseInt(value, 10);
      this.options.perPage = this._perPage;
    }

    // Get and set property accessor for gap
    get gap() {
      return this._gap;
    }

    set gap(value) {
      this._gap = value;
      this.options.gap = this._gap;
    }

    // Get and set property accessor for breakpoints
    get breakpoints() {
      return this._breakpoints;
    }

    set breakpoints(value) {
      this._breakpoints = value;
      this.options.breakpoints = { ...value };
    }

    // Get and set property accessor for mobileSlides
    get mobileSlides() {
      return this._mobileSlides;
    }

    set mobileSlides(value) {
      this._mobileSlides = parseInt(value, 10);
    }

    // Get and set property type for loop
    get type() {
      return this._type;
    }

    set type(value) {
      this._type = value;
      this.options.type = this._type;
    }

    connectedCallback() {
      this.initSlider();
    }

    // Destroy the slider when the component is disconnected from the DOM
    disconnectedCallback() {
      if (!this.slider) return;

      this.slider.destroy();
      this.slider = null;
    }

    // Initialize a new Splide slider instance with the configured options and mount it to the DOM
    initSlider() {
      const sliderElement = this.querySelector('.js-slider');
      if (!sliderElement) return;

      if (this.slider) {
        this.slider.destroy();
      }

      this.slider = new window.Splide(sliderElement, this.options).mount();
    }
  }

  customElements.define('splide-slider-component', Slider);

  // Initialize .js-featured-slider component
  document.querySelectorAll('.js-featured-slider').forEach((slider) => {
    slider.breakpoints = {
      989: {
        perPage: 2,
      },
      749: {
        perPage: 3,
      },
    };
    slider.initSlider();
  });

  // Initialize .js-product-carousel component
  document.querySelectorAll('.js-product-carousel').forEach((slider) => {
    slider.perPage = 4;
    slider.breakpoints = {
      989: {
        perPage: 3,
      },
      749: {
        perPage: 2,
        gap: '0.8rem',
      },
    };
    slider.initSlider();
  });

  // Initialize .js-social-media-carousel component
  document.querySelectorAll('.js-social-media-carousel').forEach((slider) => {
    slider.perPage = 4;
    slider.breakpoints = {
      1199: {
        perPage: 3,
      },
      989: {
        perPage: 2,
        gap: '0.8rem',
      },
      749: {
        perPage: 1,
        gap: '0.8rem',
      },
    };
    slider.initSlider();
  });
  // Initialize .js-product-image-carousel component
  document.querySelectorAll('.js-product-image-carousel').forEach((slider) => {
    slider.type = 'loop';
    slider.breakpoints = {
      3000: {
        perPage: 2,
        padding: { left: '12.5%', right: '12.5%' },
      },
      1440: {
        perPage: 1,
        padding: { left: '25%', right: '25%' },
      },
      989: {
        perPage: 1,
        padding: { left: '2rem', right: '2rem' },
        gap: '0.8rem',
      },
    };
    slider.initSlider();
  });

  // Initialize .js-collection-highlight-carousel component
  document.querySelectorAll('.js-collection-highlight-carousel').forEach((slider) => {
    slider.perPage = 4;
    slider.breakpoints = {
      989: {
        perPage: 3,
      },
      749: {
        perPage: 2,
        gap: '0.8rem',
      },
    };
    slider.initSlider();
  });

  // Initialize .js-collection-row-carousel component
  document.querySelectorAll('.js-collection-row-carousel').forEach((slider) => {
    slider.perPage = 4;
    slider.breakpoints = {
      989: {
        perPage: 3,
      },
      749: {
        perPage: 2,
        gap: '0.8rem',
      },
    };
    slider.initSlider();
  });

  // Initialize .js-product-image-carousel component
  document.querySelectorAll('.js-product-image-carousel').forEach((slider) => {
    slider.perPage = 4;
    slider.breakpoints = {
      989: {
        perPage: 3,
      },
      749: {
        perPage: 2,
        gap: '0.8rem',
      },
    };
    slider.initSlider();
  });

  // Initialize .js-carousel-articles component
  document.querySelectorAll('.js-carousel-articles').forEach((slider) => {
    slider.perPage = 4;
    slider.breakpoints = {
      989: {
        perPage: 3,
      },
      749: {
        perPage: 2,
        gap: '0.8rem',
      },
    };
    slider.initSlider();
  });

  // Initialize .js-collection-carousel component
  document.querySelectorAll('.js-collection-carousel').forEach((slider) => {
    slider.perPage = 6;
    slider.breakpoints = {
      989: {
        perPage: 4,
      },
      749: {
        perPage: 3,
        gap: '0.8rem',
      },
    };
    slider.initSlider();
  });

  // Initialize .js-garden-style-carousel (pg-carousel)
  document.querySelectorAll('.js-garden-style-carousel').forEach((slider) => {
    slider.perPage = 2;
    slider.breakpoints = {
      989: {
        perPage: 1,
      },
      749: {
        perPage: 1,
        gap: '0.8rem',
      },
    };
    slider.initSlider();
  });
  // Initialize .js-article-excerpt-carousel component
  document.querySelectorAll('.js-article-excerpt-carousel').forEach((slider) => {
    slider.perPage = 3;
    slider.breakpoints = {
      989: {
        perPage: 2,
        gap: '0.8rem',
      },
      749: {
        perPage: 1,
        gap: '0.8rem',
      },
    };
    slider.initSlider();
  });
})();

// Initialize .js-carousel-articles component
document.querySelectorAll('.js-content-category-carousel').forEach((slider) => {
  // slider.perPage = 4;
  slider.breakpoints = {
    989: {
      perPage: 3,
    },
    749: {
      perPage: 2,
      gap: '0.8rem',
    },
  };
  slider.initSlider();
});

// Initialize .js-multicolumn-usp-slider component
document.querySelectorAll('.js-multicolumn-usp-slider').forEach((slider) => {
  slider.perPage = 3;
  slider.breakpoints = {
    989: {
      perPage: 2,
      autoplay: true,
    },
    749: {
      perPage: 1,
      gap: '0.8rem',
      autoplay: true,
      type: 'loop',
    },
  };
  slider.initSlider();
});
